import { useEffect, useState, type FormEvent, type KeyboardEvent } from 'react';

import { Button } from '@flintmint/web-shared/components/button';
import { Input } from '@flintmint/web-shared/components/input';
import { useAutosizeTextArea } from '@flintmint/web-shared/hooks/use-autosize-textarea';

import styles from './assistant-message-feedback.module.scss';

export const OtherReasonForm = ({ autoFocus, onSubmit }: { autoFocus?: boolean; onSubmit: (freeText: string) => void }) => {
  const [value, setValue] = useState('');
  const trimmed = value.trim();
  const canSubmit = trimmed.length > 0;

  const textareaRef = useAutosizeTextArea(value, { maxHeight: 432 });

  useEffect(() => {
    if (autoFocus) {
      textareaRef.current?.focus();
    }
  }, [autoFocus, textareaRef]);

  const submit = () => {
    if (!canSubmit) return;
    onSubmit(trimmed);
  };

  const handleFormSubmit = (e: FormEvent) => {
    e.preventDefault();
    submit();
  };

  const handleTextareaKeyDown = (e: KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.key !== 'Enter' || e.shiftKey) return;

    e.preventDefault();
    e.stopPropagation();
    submit();
  };

  return (
    <form className={styles.otherReasonForm} onSubmit={handleFormSubmit}>
      <div className={styles.otherReasonField}>
        <Input.Textarea
          size="big"
          appearance="filled"
          value={value}
          clearable={false}
          inputRef={textareaRef}
          aria-label="Tell us what went wrong"
          placeholder="Tell us what went wrong..."
          onChange={(e) => setValue(e.target.value)}
          onKeyDown={handleTextareaKeyDown}
        />
      </div>
      <Button type="submit" fullWidth cornerRadius="rounded" disabled={!canSubmit}>
        Submit
      </Button>
    </form>
  );
};
